module.exports = __webpack_public_path__ + "media/icons/camera-700d4c12.svg";